import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { SET_USER } from './cgi-path';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
var CollabAuthRepository = /** @class */ (function () {
    function CollabAuthRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    CollabAuthRepository.prototype.setUserAuth = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var xsrf, requestParams, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        xsrf = getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) || '';
                        requestParams = __assign({ xsrf: xsrf }, params);
                        url = addURLParameters(SET_USER, { xsrf: xsrf });
                        return [4 /*yield*/, this.networkRequestService.instance.post(url, requestParams)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollabAuthRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], CollabAuthRepository);
    return CollabAuthRepository;
}());
export { CollabAuthRepository };
